import React from 'react';

import { AddressChangeDetail } from './AddressChangeDetail';
import { ChangePriceDetail } from './ChangePriceDetail';
import { SyokenDetail } from './SyokenDetail';
import { CancellationDetail } from './CancellationDetail';
import { PaymentDetail } from './PaymentDetail';

const ChangeReceptionsField = (props) => {
  const { detailData } = props;

  return (
    <>
      {/* 住所・電話番号変更 */}
      {detailData.addressChange?.id && (
        <AddressChangeDetail
          addressChange={detailData.addressChange}
          insuranceType={detailData.insuranceType}
        />
      )}
      {/* 証券再発行 */}
      {detailData.syoken?.id && (
        <SyokenDetail
          syoken={detailData.syoken}
          insuranceType={detailData.insuranceType}
        />
      )}
      {/* クレカ、口座振替 */}
      {detailData.payment?.id && (
        <PaymentDetail
          payment={detailData.payment}
          insuranceType={detailData.insuranceType}
        />
      )}
      {/* 自動車金銭異動(車両入替,運転者限定・年齢条件,使用目的変更) */}
      {(detailData.purpose?.id ||
        detailData.nenrei?.id ||
        detailData.vehicle?.id ||
        detailData.changePrice?.changeDate) && (
        <ChangePriceDetail detailData={detailData} />
      )}
      {/* 解約 */}
      {detailData.cancellation?.id && (
        <CancellationDetail
          cancellation={detailData.cancellation}
          insuranceType={detailData.insuranceType}
        />
      )}
    </>
  );
};

export default ChangeReceptionsField;
